import Vue from 'vue';
import App from './App.vue';
import VueCurrencyInput from 'vue-currency-input';

const pluginOptions = {
  globalOptions: { currency: 'CLP', locale: 'es-CL' }
};
Vue.use( VueCurrencyInput, pluginOptions );

new Vue({
  el: '#mortgageCalc',
  render: h => h( App )
});





// WEBPACK FOOTER //
// ./src/main.js